export enum KksState {
  SAP_PM = 'sap-pm',
  DMS_PROPOSED = 'dms-vorgeschlagen',
  DMS_CONFIRMED = 'dms-bestaetigt',
  NON_CONFORMING = 'nicht-konform',
  PLANNED = 'geplant',
  UNDEFINED = 'undefiniert',
  DDP_PROPOSED = 'ddp-vorgeschlagen',
}
